import { Negotiation } from '@interfaces/models/negotiation/negotiation';
import Environment from '@config/index';

export const getNegotiationIdFromUrl = (link: string): Negotiation['id'] => {
  if (!link) {
    return null;
  }
  try {
    const { searchParams } = new URL(link);
    return searchParams.get('negotiation_id');
  } catch {
    return null;
  }
};

export const getOrigin = (): string =>
  typeof window !== 'undefined' ? window.location.origin : `${Environment.baseHost}`;
